module.exports = __webpack_public_path__ + "a1b5525de4f5d11b6a21e30f8edaa546.png";